import { initRoiCalculator } from './roi-calculator.js';

document.addEventListener('DOMContentLoaded', () => {
  // 1. Initialize ROI Calculator
  initRoiCalculator();

  // 2. Intersection Observer for Scroll Reveal Animations
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.05
  };

  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.reveal').forEach(el => {
    // Check if element is already in viewport on load
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom >= 0) {
      el.classList.add('active');
    } else {
      revealObserver.observe(el);
    }
  });

  // 3. Mobile Navigation Menu Toggle
  const menuToggle = document.getElementById('menu-toggle');
  const navMobile = document.getElementById('nav-mobile');
  const navOverlay = document.getElementById('nav-overlay');
  const navClose = document.getElementById('nav-close');

  function openMobileNav() {
    if (navMobile && navOverlay) {
      navMobile.classList.add('active');
      navOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMobileNav() {
    if (navMobile && navOverlay) {
      navMobile.classList.remove('active');
      navOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileNav);
  if (navClose) navClose.addEventListener('click', closeMobileNav);
  if (navOverlay) navOverlay.addEventListener('click', closeMobileNav);

  // Close mobile menu on link click
  document.querySelectorAll('.nav-mobile-link').forEach(link => {
    link.addEventListener('click', closeMobileNav);
  });

  // 4. Accordion Toggle
  document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.parentElement;
      const isActive = item.classList.contains('active');

      // Close all other accordion items
      document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));

      // Toggle current
      if (!isActive) {
        item.classList.add('active');
      }
    });
  });

  // 5. Active Header & Mobile Nav Highlight on Scroll
  const sections = document.querySelectorAll('section[id], [id="planos"]');
  function highlightActiveNav() {
    const scrollY = window.pageYOffset;
    sections.forEach(current => {
      const sectionHeight = current.offsetHeight;
      const sectionTop = current.offsetTop - 140;
      const sectionId = current.getAttribute('id');
      const desktopLink = document.querySelector(`.nav-desktop a[href="#${sectionId}"]`);
      const mobileLink = document.querySelector(`.nav-mobile a[href="#${sectionId}"]`);

      if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
        if (desktopLink) desktopLink.classList.add('active');
        if (mobileLink) mobileLink.classList.add('active');
      } else {
        if (desktopLink) desktopLink.classList.remove('active');
        if (mobileLink) mobileLink.classList.remove('active');
      }
    });
  }

  window.addEventListener('scroll', highlightActiveNav, { passive: true });
  highlightActiveNav();

  // 6. Contact Topic Selector Dynamic WhatsApp URL Update
  const topicSelect = document.getElementById('contact-topic-select');
  const mainCtaBtn = document.getElementById('cta-launchpad-agendar');

  if (topicSelect && mainCtaBtn) {
    const phoneMatch = mainCtaBtn.getAttribute('href') ? mainCtaBtn.getAttribute('href').match(/wa\.me\/(\d+)/) : null;
    const phoneNumber = phoneMatch ? phoneMatch[1] : '5511930173654';
    topicSelect.addEventListener('change', (e) => {
      const selectedValue = e.target.value;
      const encodedText = encodeURIComponent(`Olá Diego! Vim pelo site e gostaria de conversar sobre: ${selectedValue}`);
      mainCtaBtn.setAttribute('href', `https://wa.me/${phoneNumber}?text=${encodedText}`);
    });
  }
});
